export default __webpack_public_path__ + "static/media/MasterCard.3995b077.svg";